import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { PriceOffer } from './components/PriceOffer';
import { Testimonials } from './components/Testimonials';
import { AboutAuthor } from './components/AboutAuthor';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-nunito pt-[300px]" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Navbar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <TrustBar data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <SolutionSection data-id="element-6" />
      <WhatIsIncluded data-id="element-7" />
      <PriceOffer data-id="element-8" />
      <Testimonials data-id="element-9" />
      <AboutAuthor data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}